module.exports = __webpack_public_path__ + "img/bg.16ef92f7.png";